import { useQuery } from '@tanstack/react-query'

import { marketplaceApi } from '@/lib/api/marketplace'
import { QUERY_KEYS } from '@/lib/api/query-client'

export function useMarketplace(params?: { q?: string; category?: string }) {
  return useQuery({
    queryKey: QUERY_KEYS.marketplace(params),
    queryFn: () => marketplaceApi.list(params),
    staleTime: 60 * 1000,
  })
}
